import { useRouteError } from 'react-router-dom'
import { AppErrorFallback } from '@/shared/components/app-error-fallback'

export function RouteErrorFallback() {
  const error = useRouteError()
  const normalized =
    error instanceof Error
      ? error
      : new Error(typeof error === 'string' ? error : 'This page failed to load.')
  return <AppErrorFallback error={normalized} />
}
